import request from '@/utils/requestV2'
const qs = require('qs')

/**
 * 智能设置需求画面
 * @param {Object} data 参数
 * @returns
 */
export function smartSetDemand (data) {
  return request.post('/ooh-msp/v1/ai-demand/smartSetDemand', qs.stringify(data))
}
